import { trigger, bind, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';

import { dangerouslyCreateSafeString } from '@confluence/safe-string';
import { getAnalyticsWebClient } from '@confluence/analytics-web-client';

const PREFIX = 'confluence.editor.autocomplete.fabric.mentions';

let sessionStart;
let inserted = false;

function mentionAutocompleteTrigger() {
	sessionStart = Date.now();
	inserted = false;
	trigger('analytics', {
		name: `${PREFIX}.trigger`,
		data: {},
	});
}

async function mentionAutocompleteInsert(event, data) {
	const sessionDuration = getSessionDuration(false);
	inserted = true;
	trigger('analytics', {
		name: `${PREFIX}.${getEventName('insert', sessionDuration)}`,
		data: { sessionDurationInMillis: sessionDuration },
	});

	const dataForInsertAction = {
		sessionDurationInMillis: sessionDuration,
		queryLength: data.queryLength,
		mentioneeId: dangerouslyCreateSafeString(data.mentioneeId),
		contentId: dangerouslyCreateSafeString(data.contentId),
		userType: data.userType,
		memberCount: data.memberCount,
		includesYou: data.includesYou,
	};

	trigger('analytics', {
		name: 'confluence.spa.editor.autocomplete.fabric.mentions.insert',
		data: dataForInsertAction,
	});
	const analyticsClient = await getAnalyticsWebClient();
	analyticsClient.sendUIEvent({
		action: 'inserted',
		actionSubject: 'mentionTypeahead',
		source: 'legacyEditor',
		attributes: dataForInsertAction,
	});
}

function mentionAutocompleteClose() {
	if (!inserted) {
		const sessionDuration = getSessionDuration(true);
		trigger('analytics', {
			name: `${PREFIX}.${getEventName('close', sessionDuration)}`,
			data: {
				sessionDurationInMillis: sessionDuration,
			},
		});
	}

	inserted = false;
}

function getSessionDuration(resetStart) {
	let sessionDurationInMillis = -1;
	/* istanbul ignore else */
	if (sessionStart) {
		sessionDurationInMillis = Date.now() - sessionStart;
		if (resetStart) {
			sessionStart = null;
		}
	}
	return sessionDurationInMillis;
}

/* istanbul ignore next */
function getEventName(eventPrefix, durationInMillis) {
	if (durationInMillis === -1) {
		return eventPrefix;
	} else if (durationInMillis < 1000) {
		return `${eventPrefix}.less.than.1s`;
	} else if (durationInMillis < 5000) {
		return `${eventPrefix}.less.than.5s`;
	} else if (durationInMillis < 10000) {
		return `${eventPrefix}.less.than.10s`;
	} else if (durationInMillis < 20000) {
		return `${eventPrefix}.less.than.20s`;
	} else {
		return `${eventPrefix}.more.than.20s`;
	}
}

export function initMentionAnalytics() {
	bind('init.rte', () => {
		bind('mention-autocomplete-on-start', mentionAutocompleteTrigger);
		bind('mention-autocomplete-on-select', mentionAutocompleteInsert);
		bind('mention-autocomplete-on-death', mentionAutocompleteClose);
	});

	bind('rte-destroyed', () => {
		unbind('mention-autocomplete-on-death', mentionAutocompleteClose);
		unbind('mention-autocomplete-on-select', mentionAutocompleteInsert);
		unbind('mention-autocomplete-on-start', mentionAutocompleteTrigger);
	});
}
